import { Component } from '@angular/core'
import { MbCheckoutRegions } from '../../../../models'
import { MbOrderDetailsBaseComponent } from '../mb-order-details-base.component'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-order-details-us',
  templateUrl: './mb-order-details-us.component.html',
  styleUrls: ['../mb-order-details-base.component.scss']
})
export class MbOrderDetailsUsComponent extends MbOrderDetailsBaseComponent {

  checkoutRegion = MbCheckoutRegions.US

  constructor (protected orderService: OrderHistoryService) {
    super(orderService)
  }
}
